<template>
  <div>
  <IftttForm></IftttForm>
  </div>
</template>

<script>
import IftttForm from "@/components/ifttt/IftttForm.vue";

export default {
  name: "iftttEdit",
  components: {IftttForm}
}
</script>

<style scoped>

</style>